<template>
  <el-dialog :title="form.id?'编辑':'新建'" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称" />
      </el-form-item>
      <el-form-item label="图片(尺寸320*320透明的gif图)" prop="imgUrl">
        <imageUpload v-model="form.imgUrl" width="32" height="32" />
      </el-form-item>
      <el-form-item label="零售价" prop="xdbMoney">
        <el-input v-model="form.xdbMoney" placeholder="请输入需支付零售价额度" />
      </el-form-item>
      <el-form-item label="现金" prop="cashMoney">
        <el-input v-model="form.cashMoney" placeholder="请输入需支付现金额度" />
      </el-form-item>
      <el-form-item label="排序号" prop="orderNo">
        <el-input v-model="form.orderNo" placeholder="请输入排序号" />
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <el-switch v-model="form.state" :active-value="1" :inactive-value="0" ></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import liveRewardApi from '@/api/live/liveReward'
import ImageUpload from "@/components/ImageUpload";
function initFormBean() {
  const formBean = {
    name: null,
    imgUrl: null,
    xdbMoney: null,
    cashMoney: null,
    orderNo: 1,
    state: 1
  }
  return formBean
}

export default {
  components: { ImageUpload },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        imgUrl: [{ required: true, message: '请上传图片', trigger: 'change' }],
        xdbMoney: [{ required: true, message: '请输入需支付零售价额度', trigger: 'blur' }],
        cashMoney: [{ required: true, message: '请输入需支付现金额度', trigger: 'blur' }],

      },
      isRepSub: false
    }
  },
  created() {
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            liveRewardApi.update(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            liveRewardApi.create(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
